import React from 'react';
import styled from 'styled-components';
import numeral from 'numeral';
import ProductSummaryContainer from '../ProductSummary/ProductSummaryContainer';
import { EditIcon } from '../../../components/Icons';
import RemoveIcon from '../../../components/Icons/RemoveIcon';
import { Headline, Caption2 } from '../../../components/Typography';

const Wrapper = styled.div`
  grid-gap: 4px;
  margin: 20px 0;
  display: grid;
  grid-template-columns: 6px auto;
`;

const RightBorder = styled.div`
  width: 4px;
  background-color: ${(props) => props.theme.reviewOrderButtonBackgroundColor};
  border-radius: 2px;
`;

const ContentWrapper = styled.div`
  border-bottom: ${(props) =>
    `1px solid ${props.theme.productSummaryBorderColor}`};
  padding-bottom: 12px;
`;

const TitleAndPriceWrapper = styled.div``;

const ComboTitle = styled(Headline)`
  font-size: 15px;
  font-weight: 600;
`;

const Price = styled(Caption2)`
  font-size: 12px;
  margin-top: 4px;
  color: #000;
`;

const ComboGroupWrapper = styled.div``;

const ActionRow = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
`;

const CustomizeButton = styled.span`
  color: ${(props) => props.theme.gray};
  cursor: pointer;
`;

const RemoveButton = styled(CustomizeButton)`
  justify-self: right;
`;

const ComboSummary = ({ combo, editCombo, removeCombo, validatedCart }) => {
  return (
    <Wrapper>
      <RightBorder />
      <ContentWrapper>
        <TitleAndPriceWrapper>
          <ComboTitle id='ComboSummary-ComboTitle'>{combo?.name}</ComboTitle>
          {combo?.is_dollar_discount && (
            <Price id='ComboSummary-Price'>
              {numeral(combo.totalPrice).format('$0.00')}
            </Price>
          )}
        </TitleAndPriceWrapper>
        {combo?.combo_item_groups?.map((group, groupIndex) => {
          if (!group.productCustomizer) return null;
          return (
            <ComboGroupWrapper>
              <ProductSummaryContainer
                productInCart={group.productCustomizer}
                key={`cart-combo-product-${groupIndex}`}
                isForCombo={true}
              />
            </ComboGroupWrapper>
          );
        })}
        {typeof validatedCart === 'object' && (
          <ActionRow>
            <EditIcon
              id='ComboSummary-EditComboButton'
              onClick={() => editCombo()}
            />
            <RemoveButton>
              <RemoveIcon
                id='ComboSummary-RemoveComboButton'
                onClick={() => removeCombo()}
              />
            </RemoveButton>
          </ActionRow>
        )}
      </ContentWrapper>
    </Wrapper>
  );
};

export default ComboSummary;
